import API from '../../../api'

export default {
  state: {
    endpoint: {}
  },
  mutations: {
    setEndpoint(state, endpoint) {
      state.endpoint = endpoint
    },
    setEndpointProject(state, projectId) {
      state.endpoint.project_id = projectId
    }
  },
  actions: {
    async changeEndpointProject(
      { commit },
      { endpointId, projectId, projectIdForMove }
    ) {
      const response = await API.forms.moveTo({
        endpointId,
        projectId,
        projectIdForMove
      })
      commit('setEndpointProject', projectIdForMove)
      return response
    }
  },
  getters: {
    endpoint(state) {
      return state.endpoint
    },
    endpointId(state) {
      if (state.endpoint) {
        return state.endpoint.id
      } else {
        return null
      }
    },
    endpointName(state) {
      if (state.endpoint) {
        return state.endpoint.form_name
      } else {
        return null
      }
    }
  }
}
